
import { defineComponent } from "vue";
import axios from "axios";
import { stateList } from "@/core/listas/stateList";
import InputSelect from "@/components/Inputs/InputSelect/InputSelect.vue";
import { useUsuarioStore } from "@/store/usuarioStore";

export default defineComponent({
  name: "MunicipiosUf",
  components: { InputSelect },
  props: {
    modelValue: {
      type: [String, Number],
      required: false,
      default: "",
    },
    isAvailableShow: {
      type: Boolean,
      default: true,
    },
    municipioClass: {
      type: String,
      default: "col-sm-4",
    },
    ufClass: {
      type: String,
      default: "col-sm-2",
    },
    currentUf: {
      type: String,
      default: "",
    },
    currentMunicipio: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isAvailableShowMunicipio: {
      type: Boolean,
      default: true,
    },
    municipioRequiredWhenUf: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      usuarioStore: useUsuarioStore(),
      municipios: [],
      uf: this.currentUf || "",
      municipio: this.currentMunicipio || "",
    };
  },
  computed: {
    filteredStateList() {
      // Se o usuário tem UFs específicas definidas no perfil, filtrar a lista
      if (
        this.usuarioStore.perfilDados?.uf &&
        this.usuarioStore.perfilDados.uf.length > 0
      ) {
        // Assumindo que ufs é um array de códigos de UF (por exemplo, ["AM", "CE"])
        const ufsPermitidas = this.usuarioStore.perfilDados.uf;
        return stateList.filter((state) => ufsPermitidas.includes(state.value));
      }
      // Caso contrário, retornar a lista completa
      return stateList;
    },
  },
  methods: {
    async carregarMunicipios(event) {
      const uf = event?.target?.value || event;
      if (uf) {
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_ADMIN_API}/municipio/listagem/${uf}`
          );
          let municipios = response.data.dados.map((dado) => ({
            value: dado.id,
            label: dado.nome,
          }));

          const municipioId = this.usuarioStore.perfilDados?.municipioId;
          if (municipioId) {
            municipios = municipios.filter((m) => m.value === municipioId);
            if (municipios.length === 1) {
              this.municipio = municipioId;
              this.$emit("update:modelValue", this.municipio);
            }
          }

          this.municipios = municipios;
        } catch (error) {
          this.municipios = [];
        }
      } else {
        // Se UF for limpo, também limpa municípios
        this.municipios = [];
        this.municipio = "";
        this.$emit("update:modelValue", this.municipio);
      }
    },
    onChange() {
      return this.$emit("update:modelValue", this.municipio);
    },
    selecionarUfAutomaticamente() {
      // Se tiver apenas uma UF disponível, selecionar automaticamente
      if (this.filteredStateList.length === 1 && !this.uf) {
        this.uf = this.filteredStateList[0].value;
        this.carregarMunicipios(this.uf);
      }
    },
  },
  watch: {
    currentUf(value) {
      if (value) {
        this.uf = value;
        this.carregarMunicipios(value);
      }
    },
    modelValue(modelValue) {
      this.municipio = modelValue;
    },
    isAvailableShow(value) {
      if (!value) {
        this.municipio = "";
        this.uf = "";
      }
    },
    filteredStateList: {
      immediate: true,
      handler(list) {
        this.$nextTick(() => {
          this.selecionarUfAutomaticamente();
        });
      },
    },
    uf(newUf, oldUf) {
      if (!newUf && oldUf) {
        this.municipio = "";
        this.$emit("update:modelValue", "");
      }
    },
  },
  mounted() {
    if (this.currentUf) {
      this.carregarMunicipios(this.currentUf);
    } else {
      this.selecionarUfAutomaticamente();
    }
  },
});
